import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { ConvexReactClient } from "convex/react"
import { ConvexAuthProvider } from "@convex-dev/auth/react"
import { RouterProvider } from "@tanstack/react-router"
import { Toaster } from "sonner"
import { api } from "../convex/_generated/api"
import { router } from "@/router"
import "@/styles.css"

const root = document.getElementById("root")
const convexUrl = import.meta.env.VITE_CONVEX_URL
if (!root) throw new Error("Application root is missing")
if (!convexUrl) {
	createRoot(root).render(
		<main className="auth-page">
			<div className="panel max-w-lg p-8">
				<img alt="Sumly" src="/logo-black.png" width="100" />
				<h1 className="mt-7 text-2xl font-semibold">Connect your workspace</h1>
				<p className="muted mt-3">
					Set VITE_CONVEX_URL to your Convex deployment URL and restart the app to sign in.
				</p>
			</div>
		</main>,
	)
} else {
	const convex = new ConvexReactClient(convexUrl)
	createRoot(root).render(
		<StrictMode>
			<ConvexAuthProvider
				client={convex}
				api={{ refreshSession: api.auth.refreshSession, signOut: api.auth.signOut }}
			>
				<RouterProvider router={router} />
				<Toaster richColors closeButton position="bottom-right" />
			</ConvexAuthProvider>
		</StrictMode>,
	)
}
